const navToggle = document.querySelector('.nav-main__menu-toggle');
const navMain = document.querySelector('.nav-main__menu');
const mainContent = document.querySelector('main');
const searchToggle = document.querySelector('.nav-main__search-toggle');
const searchForm = document.querySelector('.search-form');

function closeMenu() {
    if (!navMain || !navToggle || !mainContent) return;
    navMain.classList.remove('nav-open');
    navToggle.classList.remove('nav-open');
    mainContent.classList.remove('nav-open');
}

function toggleMenu() {
    if (!navMain || !navToggle || !mainContent) return;

    const willOpen = !navMain.classList.contains('nav-open');
    if (willOpen) {
        closeSearch();
    }

    navMain.classList.toggle('nav-open');
    navToggle.classList.toggle('nav-open');
    mainContent.classList.toggle('nav-open');
}

function closeSearch() {
    if (!searchForm) return;
    searchForm.classList.remove('search-open');
}

function toggleSearch() {
    if (!searchForm) return;

    const willOpen = !searchForm.classList.contains('search-open');
    if (willOpen) {
        closeMenu();
        searchForm.querySelector('input')?.focus();
    }

    searchForm.classList.toggle('search-open');

}

if (navToggle && navMain) {
    navToggle.addEventListener('click', toggleMenu);
}

if (searchToggle && searchForm) { 
    searchToggle.addEventListener('click', toggleSearch);
}
